import { render, staticRenderFns } from "./CragSectorPageHeader.vue?vue&type=template&id=c35374ee"
import script from "./CragSectorPageHeader.vue?vue&type=script&lang=js"
export * from "./CragSectorPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports